/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { FormState, FormStateBuilder } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import {
  HousePlanFinderBusinessService,
  PbHousePlanFinderDialogConfig,
} from '../../resources/house-plan-finder-business.service';
import { getPbHousePlanId, PbHousePlanFinderListItem } from '../../resources/house-plan-finder.model';
import { PbHousePlanFinderGridDefinition } from './pb-house-plan-finder-grid-definition.service';

@Component({
  selector: 'gh-house-plan-finder-dialog',
  template: require('./pb-house-plan-finder-dialog.component.html'),
  styles: [require('./pb-house-plan-finder-dialog.component.scss')],
  providers: [PbHousePlanFinderGridDefinition],
})
export class PbHousePlanFinderDialogComponent
  extends AbstractFinderDialogComponent<PbHousePlanFinderDialogConfig, PbHousePlanFinderListItem>
  implements OnInit {

  form: FormState<any>;
  getId = getPbHousePlanId;

  defaultTitle = this.translations.get('lbl_rfq_house_plans');

  constructor(public gridDefinition: PbHousePlanFinderGridDefinition,
              private translations: TranslationService,
              private formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>,
              private businessService: HousePlanFinderBusinessService) {
    super(dialogRef);
  }

  get priceBookName(): string {
    return this.input.priceBookName;
  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value: {
        priceBookId: this.input.priceBookId,
        searchString: '',
        ...this.input.filter,
      },
      children: {
        priceBookId: void 0,
        searchString: void 0,
        isQuickQuote: void 0,
        isSalesEstimate: void 0,
        allowQq: void 0,
      },
    });

    super.ngOnInit();
  }

  protected buildDataSource(): SlicedDataSource<PbHousePlanFinderListItem> {
    return this.businessService.findAllPbHousePlansAsDataSource(this.form.submitValue);
  }
}
